import React from "react";

interface Props {
  file: File;
  url: string;
  uploadImage: Function;
  initFile: Function;
}

function PreviewImage({ file, url, uploadImage, initFile }: Props) {
  return (
    <>
      <div className="preview--image">
        <div className="preview--image__container">
          <img
            src={url}
            alt=""
            onClick={() => {
              uploadImage(file);
            }}
          />
        </div>
        <div className="preview--image__footer">
          <div
            className="preview--image__btn btn--send"
            onClick={() => {
              uploadImage(file);
            }}
          >
            전송
          </div>
          <div
            className="preview--image__btn btn--cancel"
            onClick={() => {
              initFile();
            }}
          >
            취소
          </div>
        </div>
      </div>
    </>
  );
}

export default PreviewImage;
